import PropTypes from 'prop-types';

import React from 'react';
import { List } from 'immutable';

import SpellingDialog from '../SpellingDialog';
import SpellingDialogPortal from '../SpellingDialogPortal';

import SpellingStyled from './SpellingStyled';

export default class Spelling extends React.PureComponent {
  setSpellingRef = (node) => { this.el = node; };

  render() {
    return (
      <SpellingStyled onClick={this.props.onClick} ref={this.setSpellingRef}>
        {this.props.children}

        {this.props.showSuggestions && (
          <SpellingDialogPortal spellingNode={this.el}>
            <SpellingDialog
              suggestions={this.props.suggestions}
              onSuggestionClick={this.props.onSuggestionClick}
              onSkipAllClick={this.props.onRemoveSpelling}
              onClickOutside={this.props.onClickOutside}
            />
          </SpellingDialogPortal>
        )}
      </SpellingStyled>
    );
  }
}

Spelling.propTypes = {
  children: PropTypes.node,
  suggestions: PropTypes.instanceOf(List),
  showSuggestions: PropTypes.bool,
  onClick: PropTypes.func,
  onClickOutside: PropTypes.func,
  onRemoveSpelling: PropTypes.func,
  onSuggestionClick: PropTypes.func,
};
